import { createI18n } from 'vue-i18n'
// import messages from './index'
// import { getList } from '@/api/api'
import data from './index'


// const app = createApp(App)

// async function getAllList() {
//   getList().then(res => {
//     console.log(res)
//     const data = res.data.list[0]
//     const message = {
//       zhCN: {
//         'a': data.goods_alias
//       },
//       zhCT: {
//         'a': data.id
//       },
//       en: {
//         'a': data.game_list.name
//       }
//     }
//     return message
//   })
// }
const i18n = createI18n({
  legacy: false, //处理报错Uncaught (in promise) SyntaxError: Not available in legacy mode (at message-compiler.esm-bundler.js:54:19)
  // locale: localStorage.getItem('lang') || "jaJP", // 注意locale属性~~~~~~~~！
  locale: localStorage.getItem('lang') || "zhCN", // 注意locale属性~~~~~~~~！
  messages: data
})

export default i18n